import { Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Typography } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import api from "../API/api";
import { WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import BarCharts from "../CommonComponent/Charts/BarCharts";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/ColorConsultResultPage.css";

const { Title } = Typography;

export default function ColorConsultResultPage() {
  let navigate = useNavigate();
  const WH = useRecoilValue(WHState);
  const [colorTypeData, setColorTypeData] = useState<any>([]);
  const [colorPccsData, setColorPccsData] = useState<any>([]);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [value, setValue] = useState<Dayjs>(dayjs());
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = () => {
    const getData = async () => {
      setLoading(true);
      const colortype = await api.get(
        `/Result/getColorTypeResult?yyyy=${value.format("YYYY")}`
      );
      const pccs = await api.get(
        `/Result/getPccsResult?yyyy=${value.format("YYYY")}`
      );
      setLoading(false);
      if (colortype != undefined && pccs != undefined) {
        setColorTypeData(colortype);
        setColorPccsData(pccs);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const colortype = await api.get(
        `/Result/getColorTypeResult?yyyy=${value.format("YYYY")}`
      );
      const pccs = await api.get(
        `/Result/getPccsResult?yyyy=${value.format("YYYY")}`
      );
      setLoading(false);
      if (colortype != undefined && pccs != undefined) {
        setColorTypeData(colortype);
        setColorPccsData(pccs);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const ColorConstulResultSearchTextDiv = document.getElementById(
        "ColorConstulResultSearchTextDiv"
      ) as HTMLElement;
      if (div && ColorConstulResultSearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight - ColorConstulResultSearchTextDiv.clientHeight - 20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="ColorConsultResultTitle">
        ColorConsultResultPage
      </Title>
      <div id="divbox">
        <div
          className="ColorConstulResultSearchTextDiv"
          id="ColorConstulResultSearchTextDiv"
        >
          <DatePicker
            label="통계년도"
            value={value}
            onChange={(newValue: any) => setValue(newValue)}
            openTo="year"
            views={["year"]}
            format="YYYY"
            className="FitYearSearch"
          />
          <ButtonComponent
            fullWidth
            variant="contained"
            className="ColorConsultsearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
        </div>
        <div style={{ height: divboxHeight }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
              <div className="ChartWrapper">
                <Title level={4} className="ColorConsultResultTitle">
                  컬러타입
                </Title>
                <BarCharts
                  columnlabel={colorTypeData.map((item: any) => item.name)}
                  data={[colorTypeData.map((item: any) => item.count)]}
                  label={["인원"]}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
              <div className="ChartWrapper">
                <Title level={4} className="ColorConsultResultTitle">
                  pccs
                </Title>
                <BarCharts
                  columnlabel={colorPccsData.map((item: any) => item.name)}
                  data={[colorPccsData.map((item: any) => item.count)]}
                  label={["인원"]}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
